$(window).on("load",function(){
	$("body").removeClass("preload");
});
$(function(){

	var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/wp/wp-content/themes/kawabe/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		body.prepend(svg);
	});

	//スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 160) {
			body.addClass("scroll");
		} else {
			body.removeClass("scroll");
		}
	});

	//グロナビ開閉
	$('.header_menu_btn').on('click', function () {
		body.toggleClass('menu_open');
		return false;
	});

	$('.header_nav a').on('click', function () {
		body.removeClass('menu_open');
		// return false;
	});

	//閉じるボタン
	// $('.header_ac_close').on('click', function () {
	//     body.removeClass('menu_open');
	//     body.removeClass('search_open');
	// });

	//メニュー名以外の部分をクリックで閉じる
	// $('.layer').on('click', function () {
	// 	body.removeClass('menu_open');
	// 	body.removeClass('search_open');
	// });

	//アコーディオン
	$('.ac_trigger').on('click', function () {
		if($(this).hasClass('open')){
			$(this).removeClass('open');
		} else {
			$(this).addClass('open');
		}
		$(this).next(".ac_content").slideToggle();
	});

	//スマホ・PCのみ
	$(window).on('load resize', function(){
	// $(window).on('load', function(){
		var w = $(window).width();
		if (w <= 768) {
			//スマホ時
		} else {
			//PC時
		}
	});

	//トップページのみ
	if($('.home').length){

	}

});